import { render, staticRenderFns } from "./OBtnCardComp.vue?vue&type=template&id=32508e20&"
import script from "./OBtnCardComp.vue?vue&type=script&lang=js&"
export * from "./OBtnCardComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports